import RenderMarkdown from "../../../components/render-markdown.component";

const FactoryMessages = ({ messages, styles }) => (
    <div style={styles.messagesContainer}>
        {messages.map((msg) => (
            <div
                key={msg.id}
                style={{
                    margin: 0,
                    padding: 0,
                    ...styles.message,
                    ...(msg.isMine ? styles.myMessage : styles.otherMessage),
                }}
            >
                <RenderMarkdown markdownContent={msg.text} />
                <span style={styles.time}>{msg.time}</span>
            </div>
        ))}

    </div>
);

export default FactoryMessages;